import { render } from "./TaskSearchModal.vue?vue&type=template&id=89c27fe0&scoped=true"
import script from "./TaskSearchModal.vue?vue&type=script&lang=js"
export * from "./TaskSearchModal.vue?vue&type=script&lang=js"

import "./TaskSearchModal.vue?vue&type=style&index=0&id=89c27fe0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89c27fe0"]])

export default __exports__